module.exports = __webpack_public_path__ + "static/banner_left_circles-b01e65b5957a6291c85dfe348b215ff3.png";